
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["arrow-w-circle arrow-w-circle--left",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50.76","height":"50.76","viewBox":"0 0 50.76 50.76"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"circle"},[_c('circle',{staticClass:"circle",attrs:{"cx":"25.5","cy":"25.5","r":"24"}})]),_c('path',{attrs:{"d":"M38.79 25.38c0-.19-.04-.38-.11-.55 0-.01 0-.02-.01-.02-.08-.19-.19-.35-.33-.49l-7.77-7.77c-.59-.59-1.54-.59-2.12 0s-.59 1.54 0 2.12l5.21 5.21h-20.2c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h20.2l-5.21 5.21a1.49 1.49 0 000 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l7.77-7.77c.14-.14.25-.31.33-.49 0-.01 0-.02.01-.02.07-.17.11-.35.11-.55z"}})])
          )
        }
      }
    